// extracted by mini-css-extract-plugin
module.exports = {"Favorites":"Favorites_Favorites__1_R-8","Heading":"Favorites_Heading__2pPFv","spindindust":"Favorites_spindindust__1YbXY"};